function bookingIsLoggedIn() {
  let storage = localStorage.getItem('branas-booking-default');

  if (!storage) {
    return false;
  }

  storage = JSON.parse(storage);
  if (!storage) {
    return false;
  }

  const data = JSON.parse(storage.value);
  if (!data) {
    return false;
  }

  const user = data.user;
  if (!user) {
    return false;
  }

  if (!user.token) {
    return false;
  }

  return true;
}

// eslint-disable-next-line no-unused-vars
function bookingCheckLoggedInIcon(e) {
  let loggedIn = bookingIsLoggedIn();

  if (e && typeof e.detail !== 'undefined') {
    loggedIn = e.detail;
  }

  if (loggedIn) {
    document.querySelector('#login-link a').innerHTML = '<i class="fal fa-user"></i> <span>Mina sidor</span>';
  } else {
    document.querySelector('#login-link a').innerHTML = '<i class="fal fa-lock-alt"></i> <span>Logga in</span>';
  }
}

// eslint-disable-next-line no-unused-vars
function bookingStartup() {
  // setTimeout(bookingCheckLoggedInIcon, 1);
}

window.bookingIsLoggedIn = bookingIsLoggedIn;

// document.body.addEventListener('bookinguserstatechanged', bookingCheckLoggedInIcon, false);

// document.addEventListener('DOMContentLoaded', bookingStartup);



// WEBPACK FOOTER //
// ./src/lib/_user.js